// extracted by mini-css-extract-plugin
export default {"contentHeader":"ResumeClaimSubmission_contentHeader__hQsx1","appleLogo":"ResumeClaimSubmission_appleLogo__CBjHJ","resumeClaimSB":"ResumeClaimSubmission_resumeClaimSB__AUBBk"};